import axios from "axios"
import * as env from "../constants/env"


/* List Operator */
export const list = (page, search = "") => {
    const uri = `${env.startpoint}operator/list?page=${page}&search=${encodeURIComponent(search)}`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}

/* Operators Of The Admin — every filter of the panel reads this list */
export const adminOperators = (_page) => {
    const uri = `${env.startpoint}operator/user-list`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}

/* Form Variables Operator */
export const variables = () => {
    const uri = `${env.startpoint}operator/variables`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}

/* Get Operator */
export const get = (data) => {
    const uri = `${env.startpoint}operator/get`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Create Operator */
export const create = (data) => {
    const uri = `${env.startpoint}operator/create`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Edit Operator */
export const edit = (data) => {
    const uri = `${env.startpoint}operator/edit`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Regenerate The Token Of An Operator */
export const regenerate = (data) => {
    const uri = `${env.startpoint}operator/token`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Remove Operator */
export const remove = (data) => {
    const uri = `${env.startpoint}operator/remove`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}
